<script setup>
import { useMainStore } from '@/store/index'

const mainStore = useMainStore()
const embedOptions = mainStore.embedOptions
embedOptions.embed = true

const sizer = ref(null)
const AR = 16 / 9

onMounted(() => {
    if (process.client) {
        mainStore.embedOptions.initalizeIFrame()

        window.parent.postMessage(
            {
                type: 'resize',
                contentHeight: sizer.value.clientWidth * (1 / AR)
            },
            '*'
        )

        new ResizeObserver(() => {
            window.requestAnimationFrame(() => {
                window.parent.postMessage(
                    {
                        type: 'resize',
                        contentHeight: sizer.value.clientWidth * (1 / AR)
                    },
                    '*'
                )
            })
        }).observe(sizer.value)
    } else {
        initialized.value = true
    }
})
</script>

<template>
    <div class="embed-global-wrapper" ref="sizer">
        <slot />
    </div>
</template>
<style scoped>
.embed-global-wrapper {
    background: transparent;
    width: 100%;
    margin: 0 auto;
    aspect-ratio: 16 / 9;
}
</style>
<style>
.v-application__wrap {
    margin: 0;
    padding: 0;
    background: transparent;
}
</style>
